<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div class="en-box">
                    <div data-lang="cn" class="main-wrap">
                        <div class="main-content">
                            <main class="wrapper">
                                <div class="calculator">
                                    <div class="breadcrumb-box">
                                        <div class="breadcrumb-link-item">
                                            <a href="/jinrong/" class="breadcrumb-link">交易学院</a>
                                        </div>
                                        <div class="breadcrumb-link-item">
                                            <a href="/forex-tools/" class="breadcrumb-link">交易计算器</a>
                                        </div>
                                        <div class="breadcrumb-link-item">
                                            <span class="breadcrumb-link">损益百分比计算器</span>
                                        </div>
                                    </div>
                                    <section class="section1">
                                        <div class="calculator__wrap">
                                            <h1>损益百分比计算器</h1>
                                            <div class="forex-title-intro">
                                                <p>
                                                    此在线损益百分比计算器可快速告诉您您赢或输的帐户余额百分比。它还估计了再次达到盈亏平衡点所需的当前余额的百分比。或者，您可以输入百分比并查看货币收益或损失的大小。
                                                </p>

                                                <p>
                                                    计算器将在您填写字段时完成其工作。您可以通过单击按钮在损失和收益之间切换。您甚至可以通过填写当前余额和最近的余额变化来了解您的起始余额。
                                                </p>
                                            </div>
                                            <form data-formula="CalcSize" name="f" id="calculator"
                                                class="calculator__form form form-calculator">
                                                <label for="start-input" class="field-input"><span
                                                        class="field-label"><strong>您的余额为 ($)</strong></span>
                                                    <input id="start-input" name="start-input" placeholder="—"
                                                        data-start-input="" type="text" class="field" /></label>
                                                <div class="field-input">
                                                    <span class="field-label"><strong>和你</strong></span>
                                                    <label class="status-button"><input type="checkbox"
                                                            data-state-checkbox="" checked="checked"
                                                            class="status-button__input" />
                                                        <span
                                                            class="status-button__text status-button__text--won">盈利了</span>
                                                        <span
                                                            class="status-button__text status-button__text--lost">亏损了</span></label>
                                                </div>
                                                <label for="change-input" class="field-input"><span
                                                        class="field-label"><strong>$</strong></span>
                                                    <input id="change-input" name="change-input" placeholder="—"
                                                        data-change-input="" type="text" class="field" /></label>
                                                <label for="per-input" class="field-input"><span
                                                        class="field-label"><strong>盈利百分比为（％）</strong></span>
                                                    <input id="per-input" name="per-input" placeholder="—"
                                                        data-per-input="" type="text" class="field" /></label>
                                                <label for="current-input" class="field-input"><span
                                                        class="field-label"><strong>您当前的余额为 ($)</strong></span>
                                                    <input id="current-input" name="current-input" placeholder="—"
                                                        data-current-input="" type="text" class="field" /></label>
                                                <div class="form-calculator__res">
                                                    <p data-can-regain="" class="flash-p" style="display: none">
                                                        您<span data-state-won="">必须要盈利</span><span data-state-lost=""
                                                            style="display: none">现在能够承受</span>
                                                        <span data-per=""></span><span data-state-won="">,
                                                            才能重回初始余额。</span><span data-state-lost=""
                                                            style="display: none">,
                                                            的亏损，达到这一百分比时，将重新回到初始余额。</span>
                                                    </p>
                                                    <p data-cannot-regain="" style="display: none">
                                                        您无法恢复余额。
                                                    </p>
                                                </div>
                                            </form>
                                        </div>
                                    </section>
                                    <section class="section2">
                                        <h3 class="pivot-point-calc-card__title">
                                            为什么要使用它？
                                        </h3>
                                        <div class="pivot-point-calc-card__text">
                                            <p>
                                                您可以使用它来更好地了解您在白天或其他时段在外汇交易中赢了或输了多少。您还将知道您需要重新获得多少才能达到收支平衡，或者在返回起始资金之前您可以承受多少损失
                                            </p>
                                            <p>
                                                计算器还会根据最终余额和导致该余额的损益大小告诉您初始资本是多少。
                                            </p>
                                        </div>
                                    </section>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
                <section class="forex-section">
                    <footerDetail></footerDetail>
                </section>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import calcs from "../../assets/js/calcs.js";
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import footerDetail from "../../components/footer-detail/footer-detail.vue";

export default {
    components: {
        forexMenu,
        footerDetail
    },
    mounted() {
        calcs();
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

body {
    font-size: 16rem;
}

.section1 {
    margin-top: 50rem;
}

section+section {
    margin-top: 88rem;
}

.nuxt-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    width: 0;
    opacity: 1;
    -webkit-transition: width 0.1s, opacity 0.4s;
    -o-transition: width 0.1s, opacity 0.4s;
    -moz-transition: width 0.1s, opacity 0.4s;
    transition: width 0.1s, opacity 0.4s;
    background-color: #4fd1c5;
    z-index: 999999;
}

.nuxt-progress.nuxt-progress-notransition {
    -webkit-transition: none;
    -o-transition: none;
    -moz-transition: none;
    transition: none;
}

.nuxt-progress-failed {
    background-color: red;
}

.field {
    border-radius: 8rem !important;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none !important;
}

body p {
    margin-bottom: 21px;
    margin-top: 0;
}

body.fixed-header {
    padding-top: 62px;
}

body.fixed-header {
    padding-top: 142px;
}

body.fixed-header .header {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 100;
    top: 0;
    -webkit-transform: translateY(-100%);
    -moz-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    -o-transform: translateY(-100%);
    transform: translateY(-100%);
}

body.fixed-header .header .header__top {
    display: none;
}

body.fixed-header.top .header {
    -webkit-transition: -webkit-transform 0.3s ease-in-out;
    transition: -webkit-transform 0.3s ease-in-out;
    -o-transition: -o-transform 0.3s ease-in-out;
    -moz-transition: transform 0.3s ease-in-out, -moz-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out,
        -moz-transform 0.3s ease-in-out, -o-transform 0.3s ease-in-out;
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
}

svg path {
    -webkit-transition: fill 0.3s ease-in-out;
    -o-transition: fill 0.3s ease-in-out;
    -moz-transition: fill 0.3s ease-in-out;
    transition: fill 0.3s ease-in-out;
}

.wrapper {
    margin: auto;
    padding-right: 0;
    padding-left: 0;
}

.code,
kbd,
samp {
    font-family: inherit;
    font-size: inherit;
}

.accent {
    color: #c49a6c;
}

.error-msg {
    color: #f66363;
}

fieldset {
    border: none;
    padding: 0;
}

.content-banner {
    width: 100%;
    margin: 40px 0;
    text-align: center;
}

.content-banner img {
    margin: 0;
    width: auto;
    height: auto;
}

.content-banner iframe,
.content-banner img,
.content-banner ins {
    max-width: 100%;
}

.fade-modal-enter-active,
.fade-modal-leave-active {
    -webkit-transition: opacity 0.5s;
    -o-transition: opacity 0.5s;
    -moz-transition: opacity 0.5s;
    transition: opacity 0.5s;
}

.fade-modal-enter,
.fade-modal-leave-to {
    opacity: 0;
}

.highlight {
    background: #8391a4;
    color: #2d3748;
}

.ar .info-card__btns .btn:not(.--grey),
.rtl .info-card__btns .btn:not(.--grey) {
    margin-right: 0;
    margin-left: 14px;
}

.ar .field-input.--required:after,
.rtl .field-input.--required:after {
    left: 12px;
    right: auto;
}

@-moz-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-webkit-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-o-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-moz-keyframes rotation {
    0% {
        -moz-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -moz-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-webkit-keyframes rotation {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -webkit-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-o-keyframes rotation {
    0% {
        -o-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -o-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@keyframes rotation {
    0% {
        -webkit-transform: rotate(0);
        -moz-transform: rotate(0);
        -o-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -webkit-transform: rotate(2turn);
        -moz-transform: rotate(2turn);
        -o-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-moz-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-webkit-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-o-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-moz-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@-webkit-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@-o-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

.page-header {
    margin-bottom: 41px;
}

.page-header__content {
    max-width: 730px;
}

.page-header__label {
    font-weight: 500;
    text-transform: uppercase;
    line-height: 16px;
    color: #8391a4;
    font-size: 10px;
    margin: 39px 0 -28px;
}

.page-header__text {
    margin-bottom: 19px;
}

.page-header a {
    text-decoration: underline;
    text-underline-offset: 2px;
}

.brokers__results {
    margin-bottom: 71px;
}

.brokers__results {
    margin: 0 -16px 101px;
}

.btn {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    border: 1px solid #c49a6c;
    padding: 9px 23px 8px;
    display: inline-block;
    color: #2d3748;
    background-color: rgba(0, 0, 0, 0);
}

.btn {
    cursor: pointer;
    -webkit-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    -o-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    -moz-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    transition: color 0.3s, background-color 0.3s, border-color 0.3s ease-in-out;
}

.btn:hover {
    background-color: #4fd1c5;
    color: #fff !important;
}

.btn:hover svg path {
    fill: #fff;
}

.btn.--small {
    padding: 2px 24px;
}

.btn.--grey {
    border-color: #8391a4;
    color: #8391a4;
}

.btn.--grey:hover {
    border-color: #4fd1c5;
    color: #fff;
}

.btn.--grey:hover svg path {
    fill: #fff;
}

.btn.--grey svg path {
    fill: #8391a4;
}

.btn.--green {
    border-color: #4fd1c5;
    color: #fff;
    background-color: #4fd1c5;
}

.btn.--green:hover {
    color: #4fd1c5 !important;
    background-color: #fff;
}

.btn.--inverted {
    border-color: #fff;
    color: #fff;
}

.btn.--inverted:hover {
    background-color: #088a7e;
    border-color: #088a7e;
}

.btn.--dark-green {
    border-color: #088a7e;
    color: #088a7e;
}

.btn.--dark-green:hover {
    border-color: #fff;
    color: #fff;
}

.btn.--white {
    border-color: #fff;
    color: #fff;
}

.btn.--white:hover {
    border-color: #2d3748;
    color: #2d3748 !important;
}

.btn.--disabled {
    border-color: #8391a4;
    color: #8391a4;
    pointer-events: none;
    opacity: 0.6;
}

.load-btn {
    -webkit-appearance: none;
    background-color: rgba(0, 0, 0, 0);
    outline: 0;
    border: none;
    text-transform: uppercase;
    padding: 7px 5px 7px 47px;
    position: relative;
    font-weight: 500;
    line-height: 22px;
    color: #8391a4;
}

.load-btn {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.load-btn:hover {
    cursor: pointer;
    color: #4fd1c5;
}

.load-btn:hover svg path {
    fill: #4fd1c5;
}

.load-btn svg {
    position: absolute;
    left: 17px;
    top: 9px;
}

/* .calculator__title {
    color: #fff;
} */

.calculator__wrap {}

.calculator__wrap form {
    border-radius: 8rem;
    overflow: hidden;
}

.calculator__wrap .calculator__desc {
    color: #222222;
    margin-bottom: 40px;
}

.calculator__subtitle {
    margin: 0 0 40px;
}

.calculator__subtitle {
    margin-bottom: 20px;
    max-width: 1080px;
}

.calculator__desc {
    font-size: 14px;
    line-height: 1.5;
    max-width: 700px;
    margin-bottom: 70px;
}

.calculator__desc {
    margin-bottom: 100px;
}

.calculator__form .btn {
    /* width: -webkit-min-content;
  width: -moz-min-content;
  width: min-content; */
    min-height: 42rem;
    grid-column: 1/-1;
    white-space: nowrap;
    background: #a52933;
    color: #fff;
    font-size: 16rem;
    border: none;
}

.calculator__form .input__label {
    display: block;
    font: 400 10px/1.3 TTTravels, sans-serif;
    margin-bottom: 10px;
}

.calculator__form .input__label strong {
    font-size: 15px;
}

.calculator__form {
    display: grid;
    background: #f9fafc;
    margin-top: 48rem;
    grid-template-columns: 1fr 1fr;
    grid-gap: 18rem 40rem;
    padding: 32rem 24rem 40rem;
}

.calculator__result {
    display: none;
}

.calculator__result {
    padding: 32rem 24rem;
    background: #fbfcfd;
}

.calculator__result-row {
    background: #fbfcfd;
    padding: 30px;
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 15px;
    border-top: 1px solid #e4e7ea;
}

.calculator__result-row {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 0;
    padding: 19px 0 18px;
}

.calculator__result-row.--header {
    display: none;
}

.calculator__result-row.--header {
    display: grid;
    padding: 38px 0;
    border-top: 1px dashed #c4d4e9;
}

.calculator__result-row.--header .calculator__result-cell {
    text-transform: uppercase;
    color: #8391a4;
    font-weight: 500;
    font-size: 12rem;
    line-height: 1.6;
}

.calculator__result-cell {
    font-size: 14rem;
}

.calculator__result-cell:before {
    content: attr(title);
    display: block;
    font-size: 10px;
    min-height: 16px;
    font-weight: 500;
    color: #8391a4;
    margin-bottom: 4px;
}

.calculator__result-cell:before {
    display: none;
}

.calculator__result-cell:first-child {
    font-weight: normal;
    font-size: 15rem;
    letter-spacing: -0.02em;
    font-family: TTTravels;
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ea;
    grid-column: 1/3;
}

.calculator__result-cell:first-child:before {
    margin-bottom: 0;
}

.calculator__result-cell:first-child {
    grid-column: unset;
    padding-bottom: 0;
    border-bottom: none;
}

.calculator__result.--open {
    display: block;
}

.calculator__result.--pip-calculator .calculator__result-row,
.calculator__result.--position-size-calculator .calculator__result-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    grid-template-columns: repeat(2, 200px);
}

.calculator__result.--pivot-points-calculator .calculator__result-row,
.calculator__result.--risk-reward-calculator .calculator__result-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    grid-template-columns: repeat(5, 1fr);
}

.calculator__buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    grid-gap: 20px;
    grid-column: 1/-1;
}

body .tippy-tooltip.light-border-theme {
    font-size: 11px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    color: #000;
    color: initial;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    line-height: 1.3;
    border: 1px solid #e4e7ea;
}

body .tippy-tooltip.light-border-theme a {
    color: #4fd1c5;
}

body .tippy-tooltip.light-border-theme a:hover {
    color: #088a7e;
}

input[placeholder] {
    color: #8391a4;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::-ms-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::placeholder {
    color: #8391a4;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::-webkit-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:-moz-placeholder,
input::-moz-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:-ms-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus::-webkit-input-placeholder {
    opacity: 0;
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus::-moz-placeholder {
    opacity: 0;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus:-moz-placeholder {
    opacity: 0;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus:-ms-input-placeholder {
    opacity: 0;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input[type="date"],
input[type="email"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"],
textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 1px solid #e4e7ea;
    padding: 13px 15px 11px;
    width: 100%;
    color: #2d3748;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
}

textarea {
    height: 138px;
    resize: none;
}

.custom-dropdown {
    position: relative;
    z-index: 2;
    width: 100%;
    margin-bottom: 20px;
}

.custom-dropdown.cs-open {
    z-index: 3;
}

.custom-dropdown.cs-open .cs-placeholder {
    display: block;
}

.custom-dropdown.cs-open .cs-placeholder:after {
    -webkit-transform: rotateX(160deg);
    -moz-transform: rotateX(160deg);
    transform: rotateX(160deg);
}

.custom-dropdown.cs-open .cs-options {
    display: block;
}

.custom-dropdown .cs-placeholder {
    color: #2d3748;
    position: relative;
    z-index: 2;
    border: 1px solid #e4e7ea;
    cursor: pointer;
    padding: 11px 24px 7px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    width: 100%;
}

.custom-dropdown .cs-placeholder {
    cursor: pointer;
}

.custom-dropdown .cs-placeholder:after {
    content: "";
    width: 0;
    height: 0;
    border-top: 5px solid #2d3748;
    border-left: 4px solid rgba(0, 0, 0, 0);
    border-right: 4px solid rgba(0, 0, 0, 0);
    position: absolute;
    left: 8px;
    top: 19px;
    -webkit-transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    -o-transition: border-color 0.3s ease-in-out, -o-transform 0.3s;
    -moz-transition: transform 0.3s, border-color 0.3s ease-in-out,
        -moz-transform 0.3s;
    transition: transform 0.3s, border-color 0.3s ease-in-out;
    transition: transform 0.3s, border-color 0.3s ease-in-out,
        -webkit-transform 0.3s, -moz-transform 0.3s, -o-transform 0.3s;
}

.custom-dropdown .cs-options {
    margin: 0;
    color: #2d3748;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    display: none;
    -webkit-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    -moz-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    list-style: none;
    z-index: 1;
    overflow-y: auto;
    max-height: 350px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 7px 0;
}

.custom-dropdown .cs-options {
    scrollbar-color: #4fd1c5 rgba(0, 0, 0, 0);
    scrollbar-width: thin;
}

.custom-dropdown .cs-options::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.custom-dropdown .cs-options::-webkit-scrollbar {
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
}

.custom-dropdown .cs-options::-webkit-scrollbar-thumb {
    background-color: #4fd1c5;
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
}

.custom-dropdown .cs-item {
    margin: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: block;
}

.custom-dropdown .cs-item {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.custom-dropdown .cs-item:hover {
    color: #4fd1c5;
}

.custom-dropdown .cs-item .hidden-cbx {
    display: none;
}

.custom-dropdown .cs-item .hidden-cbx:checked+.rbx-option {
    color: #4fd1c5;
    pointer-events: none;
}

.custom-dropdown .rbx-option {
    display: block;
    padding: 5px 24px;
    cursor: pointer;
}

.field-input {
    margin-bottom: 20px;
    display: block;
    -webkit-align-self: flex-start;
    -ms-flex-item-align: start;
    align-self: flex-start;
}

.field-input.--required {
    position: relative;
}

.field-input.--required:after {
    content: "*";
    line-height: 0;
    position: absolute;
    right: 12px;
    bottom: 17px;
}

.field-input .field-label {
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    color: #8391a4;
    margin-bottom: 5px;
    display: block;
}

.field-input .field-label strong {
    font-family: TTTravels;
    font-weight: normal;
    font-size: 14rem;
    /* line-height: 19px; */
    /* letter-spacing: -0.02em; */
    color: #232222;
}

.form-calculator .calc-label-risk {
    display: block;
}

.form-calculator .calc-label-money,
.form-calculator .change-units .calc-label-risk {
    display: none;
}

.form-calculator .change-units .calc-label-money {
    display: block;
}

.table-calculator .calc-label-risk {
    display: none;
}

.table-calculator .calc-label-money,
.table-calculator .change-units .calc-label-risk {
    display: block;
}

.table-calculator .change-units .calc-label-money {
    display: none;
}

.btn.field {
    margin: 28px 0 20px;
}

.app-select {
    position: relative;
    z-index: 2;
    width: 100%;
    margin-bottom: 20px;
}

.app-select.--light .app-select__selected {
    background-color: rgba(0, 0, 0, 0);
    border-color: #e4e7ea;
    color: #2d3748;
}

.app-select.--light .app-select__selected:after {
    border-top-color: #2d3748;
}

.app-select.--open {
    z-index: 3;
}

.app-select.--open .app-select__selected:after {
    -webkit-transform: rotateX(160deg);
    -moz-transform: rotateX(160deg);
    transform: rotateX(160deg);
}

.app-select.--open .app-select__dropdown {
    display: block;
}

.app-select.--disabled {
    pointer-events: none;
    opacity: 0.6;
}

.app-select.--error .app-select__selected {
    border-color: #f66363;
}

.app-select__label {
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-transform: uppercase;
    color: #8391a4;
    margin-bottom: 5px;
    display: block;
}

.app-select__selected {
    position: relative;
    background-color: #2d3748;
    border: 1px solid rgba(228, 231, 234, 0.2);
    cursor: pointer;
    padding: 11px 24px 7px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
}

.app-select__selected {
    cursor: pointer;
}

.app-select__selected:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 4px solid rgba(0, 0, 0, 0);
    border-right: 4px solid rgba(0, 0, 0, 0);
    border-top: 5px solid #fff;
    position: absolute;
    left: 8px;
    top: 19px;
    -webkit-transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    -o-transition: border-color 0.3s ease-in-out, -o-transform 0.3s;
    -moz-transition: transform 0.3s, border-color 0.3s ease-in-out,
        -moz-transform 0.3s;
    transition: transform 0.3s, border-color 0.3s ease-in-out;
    transition: transform 0.3s, border-color 0.3s ease-in-out,
        -webkit-transform 0.3s, -moz-transform 0.3s, -o-transform 0.3s;
}

.app-select__selected span {
    display: inline-block;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

.app-select__dropdown {
    color: #2d3748;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    display: none;
    -webkit-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    -moz-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    min-width: 100%;
}

.app-select__items {
    overflow-y: auto;
    max-height: 350px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 7px 0;
}

.app-select__items {
    scrollbar-color: #4fd1c5 rgba(0, 0, 0, 0);
    scrollbar-width: thin;
}

.app-select__items::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.app-select__items::-webkit-scrollbar {
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
}

.app-select__items::-webkit-scrollbar-thumb {
    background-color: #4fd1c5;
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
}

.app-select__item {
    padding: 5px 24px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.app-select__item {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.app-select__item:hover {
    color: #4fd1c5;
}

.app-select__item.--active {
    color: #4fd1c5;
    pointer-events: none;
}

.app-select__item.--placeholder {
    color: #a0aec0;
}

.app-select__wrap.--error .app-select__selected {
    border-color: #f66363;
}

#calc-modal-ok {
    background: #c49a6c;
    color: #fff;
    font-size: 16px;
}

#calc-modal-ok:hover {
    background: #c49a6c;
}

@media (max-width: 996px) {
    .calculator__cards {
        margin-bottom: 28px;
    }
}

.home-header-bd .navbar-brand {
    padding-top: 6px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.calculator__cards {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 70px;
}

.calculator__cards {
    grid-gap: 40px;
    gap: 40px;
    margin-bottom: 80px;
}

.calculator__cards-item {
    padding: 20px 0;
}

.pivot-point-calc-card {
    background: #fff;
}

.pivot-point-calc-card__title {
    font-size: 20rem;
    margin: 0 0 20px;
}

.pivot-point-calc-card__title {
    margin-bottom: 18px;
}

.pivot-point-calc-card__text {
    font-size: 14rem;
    line-height: 1.5;
}

.pivot-point-calc-card__text p {
    margin: 0 0 22px;
}

.pivot-point-calc-card__text {
    line-height: 1.55;
}

.pivot-point-calc-card__formulas {
    padding: 15rem;
    border: 1px solid #c49a6c;
    font-size: 14rem;
}

.pivot-point-calc-card__formulas p {
    margin: 0;
}

.pivot-point-calc-card__formulas {
    padding: 17px 20px;
    line-height: 1.6;
}

.calc-modal {
    position: fixed;
    z-index: 9999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    display: none;
}

.calc-modal.--open {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
}

.calc-modal__hider {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 1;
    cursor: pointer;
}

.calc-modal__content {
    position: relative;
    width: 300px;
    padding: 20px 25px;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-top: 5px solid #c49a6c;
    z-index: 5;
}

.calc-modal__content {
    width: 600px;
    padding: 50px 25px;
}

.calc-modal__text {
    margin: 0 0 30px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #c49a6c;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #8c5c27;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #4fd1c5;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #088a7e;
}

.info-banner {
    color: #4fd1c5;
    padding: 27px 28px 7px;
    margin: 20px 0;
    border: 2px solid #4fd1c5;
}

.info-banner.--warning {
    background-color: #fbc334;
    border-color: #fbc334;
    color: #fff;
}

.info-banner.--warning .info-banner__icon {
    background-image: url(../../assets/image/forex/tools/warning-icon.svg);
}

.info-banner.--warning a:not([class]) {
    text-decoration: underline;
    color: #fff;
    -webkit-text-decoration-color: #ffe49e;
    -moz-text-decoration-color: #ffe49e;
    text-decoration-color: #ffe49e;
}

.info-banner.--warning a:not([class]):visited {
    color: #ffe193;
}

.info-banner.--warning a:not([class]):hover {
    color: #ffe193;
}

.info-banner.--info {
    background-color: #4fd1c5;
    border-color: #4fd1c5;
    color: #fff;
}

.info-banner.--info .info-banner__icon {
    /* background-image: url(../../assets/image/forex/tools/like-icon.svg); */
}

.info-banner.--info a:not([class]) {
    color: #fff;
    text-decoration: underline;
    -webkit-text-decoration-color: #eee;
    -moz-text-decoration-color: #eee;
    text-decoration-color: #eee;
}

.info-banner.--info a:not([class]):visited {
    color: #eee;
}

.info-banner.--info a:not([class]):hover {
    color: #eee;
}

.info-banner__icon {
    width: 60px;
    height: 60px;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-position: 50%;
    -moz-background-size: contain;
    background-size: contain;
    background-image: url(/svg/idea-icon.svg);
    margin-bottom: 30px;
}

.info-banner__content {
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -moz-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.info-banner h3,
.info-banner h4 {
    margin: 0;
    max-width: 100%;
}

.info-banner h4 {
    font-size: 22px;
    line-height: 29px;
}

.info-banner p {
    margin-top: 0;
    max-width: 100%;
}

.info-banner a:not([class]) {
    color: #4fd1c5;
    -webkit-text-decoration-color: #8ce9e1;
    -moz-text-decoration-color: #8ce9e1;
    text-decoration-color: #8ce9e1;
}

.info-banner a:not([class]):visited {
    color: #8ce9e1;
}

.info-banner a:not([class]):hover {
    color: #4fd1c5;
}

.info-banner__text {
    margin-top: 20px;
    max-width: 690px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.risk-reward__info {
    margin-bottom: 70px;
}

.risk-reward__info {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.risk-reward__about {
    margin-bottom: 40px;
}

.risk-reward__about {
    width: 100%;
    max-width: 600px;
    margin-right: 80px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
}

.risk-reward__title {
    margin-top: 0;
}

.risk-reward__title {
    margin: 0;
    grid-column: 1/-1;
}

.risk-reward__desc {
    margin-bottom: 40px;
    line-height: 1.3;
}

.risk-reward__desc {
    grid-column: 1/-1;
    margin: -20px 0 0;
}

.risk-reward__text {
    color: #a0aec0;
    line-height: 1.3;
}

.risk-reward__text {
    margin-bottom: 0;
}

.risk-reward__images {
    margin: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
}

.risk-reward__images {
    width: 100%;
    max-width: 760px;
    grid-gap: 40px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #c49a6c;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #088a7e;
}

.sect-list {
    padding: 1px 0;
    margin-bottom: 35px;
}

.sect-list {
    margin-bottom: 50px;
}

.sect-list.--five-cols .sect-list__list-item {
    width: 20%;
}

.sect-list.--five-cols .sect-list__list-item:nth-of-type(4n) {
    padding-right: 35px;
}

.sect-list.--five-cols .sect-list__list-item:nth-of-type(5n) {
    padding-right: 0;
}

.sect-list h2,
.sect-list h3 {
    max-width: 1045px;
}

.sect-list h4 {
    max-width: 810px;
}

.sect-list__list {
    padding: 0;
    list-style-type: none;
    margin: 28px 0 20px;
    font-size: 14px;
}

.sect-list__list-item {
    padding-top: 24px;
    position: relative;
    margin-bottom: 9px;
}

.sect-list__list-item {
    width: 25%;
    margin-bottom: 30px;
    padding-right: 35px;
}

.sect-list__list-item:nth-of-type(3n) {
    padding-right: 35px;
}

.sect-list__list-item:nth-of-type(4n) {
    padding-right: 0;
}

.sect-list__list-item:before {
    content: "";
    background-color: #4fd1c5;
    height: 4px;
    width: 35px;
    display: block;
    position: absolute;
    top: 10px;
    left: 0;
}

.sect-list__list-item a {
    color: #4fd1c5;
}

.sect-list__list-item a:hover {
    color: #088a7e;
}

.sect-list__text {
    max-width: 720px;
}

.sect-list__footer-text {
    font-family: TTTravels;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: -0.02em;
    margin-top: 40px;
}

.sect-list__footer-tip {
    color: #8391a4;
    max-width: 1030px;
    margin-top: 41px;
}

.ar .sect-list__list-item,
.rtl .sect-list__list-item {
    padding-right: 0;
    padding-left: 35px;
}

.ar .sect-list__list-item:before,
.rtl .sect-list__list-item:before {
    left: unset;
    right: 0;
}

.form-calculator__res {
    grid-column: 1/1;
    grid-row: 6/6;
}

.form-calculator__res {
    grid-column: 1/3;
    grid-row: 4/4;
}

.form-calculator__res p {
    border-top: 1px dashed #8391a4;
    padding-top: 12px;
}

.form-calculator .state-lost-text {
    color: #f66363;
}

.form-calculator .state-won-text {
    color: #4fd1c5;
}

.form-calculator .status-button {
    display: inline-block;
}

.form-calculator .status-button__text {
    display: none;
    color: #fff;
    padding: 9px 15px;
    min-width: 150px;
    text-align: center;
    cursor: pointer;
}

.form-calculator .status-button__text.status-button__text--won {
    background-color: #3dbd82;
}

.form-calculator .status-button__text.status-button__text--lost {
    background-color: #f66363;
}

.form-calculator .status-button__input {
    display: none;
}

.form-calculator .status-button__input:checked~.status-button__text--won,
.form-calculator .status-button__input:not(:checked)~.status-button__text--lost {
    display: inline-block;
}

@media (max-width: 996px) {
    .calculator__form {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 18rem;
        background: #f9fafc;
        padding: 30rem 30rem 28rem;
        border-radius: 8rem;
    }

    .field-input .field-label strong {
        font-size: 28rem;
    }

    input[type="date"],
    input[type="email"],
    input[type="number"],
    input[type="password"],
    input[type="tel"],
    input[type="text"],
    textarea {
        font-size: 24rem;
    }

    .calculator__form .btn {
        font-size: 32rem;
        height: 80rem;
        border-radius: 16rem;
    }

    .pivot-point-calc-card__title {
        font-size: 40rem;
    }

    .pivot-point-calc-card__text {
        font-size: 28rem;
    }

    .pivot-point-calc-card__formulas {
        font-size: 28rem;
    }

    .calculator__result-row.--header .calculator__result-cell {
        font-size: 24rem;
    }

    .calculator__result-cell {
        font-size: 28rem;
    }

    .calculator__result-cell:first-child {
        font-size: 30rem;
    }

    .calculator__result {
        padding: 0 30rem;
    }

    .video-list-box {
        display: none;
    }

    .article-item {
        display: none;
    }

    .article-item:nth-child(-n + 2) {
        display: flex;
    }

    .field {
        border-radius: 16rem !important;
    }
}
</style>